import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from './Icons';
export function WhatsInside() {
  const chapters = [{
    label: 'INTRO',
    title: 'El Problema que Nadie Nombra',
    desc: 'Por qué la manifestación tradicional falla biológicamente y cómo el Protocolo RNS lo resuelve.',
    pages: '5 páginas'
  }, {
    label: 'CAP.01',
    title: 'La Biología del Bloqueo Financiero',
    desc: 'Cómo tu SAR filtra las oportunidades + Ejercicio: Escáner Corporal del Dinero.',
    pages: '9 páginas'
  }, {
    label: 'CAP.02',
    title: 'Tu Sistema Nervioso Decide Cuánto Dinero Puedes Tener',
    desc: 'El Nervio Vago, trauma financiero, 7 síntomas del bloqueo + Sacudida Somática.',
    pages: '9 páginas'
  }, {
    label: 'CAP.03',
    title: 'Re-programando tu SAR Financiero',
    desc: 'Escritura Neural con 7 plantillas listas para usar desde el Día 1.',
    pages: '9 páginas'
  }, {
    label: 'CAP.04',
    title: 'El Protocolo de 21 Días',
    desc: 'Las 3 semanas completas día a día + tabla de seguimiento + señales de progreso.',
    pages: '14 páginas'
  }, {
    label: 'CAP.05',
    title: 'Cómo Retener la Riqueza que Llega',
    desc: 'El termostato financiero, identidad permanente y el ciclo de expansión continua.',
    pages: '7 páginas'
  }];
  const extras = ['Plantillas de Escritura Neural para 7 días', 'Tabla de seguimiento de 21 días imprimible', 'Checklist de los 7 síntomas del trauma', 'Glosario RNS con 12 términos científicos'];
  return <section className="bg-primary py-10 md:py-16 px-4 md:px-12" data-id="element-313">
      <div className="max-w-5xl mx-auto" data-id="element-314">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12 md:mb-16" data-id="element-315">
          <h2 className="font-playfair font-bold text-3xl md:text-5xl text-warm-white mb-4" data-id="element-316">
            Todo lo que incluye El Protocolo RNS
          </h2>
          <p className="font-playfair italic text-xl md:text-2xl text-gold" data-id="element-317">
            55 páginas de neurociencia aplicada. Cero relleno.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-12 md:mb-16" data-id="element-318">
          {chapters.map((chapter, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-secondary border border-card rounded-xl p-5 md:p-6 text-center hover:border-gold/50 transition-colors" data-id="element-319">
              <div className="font-inter font-bold text-gold text-sm tracking-widest mb-2" data-id="element-320">
                {chapter.label}
              </div>
              <h3 className="font-inter font-semibold text-lg md:text-xl text-warm-white mb-2" data-id="element-321">
                {chapter.title}
              </h3>
              <p className="font-inter text-warm-muted text-sm leading-relaxed mb-4" data-id="element-322">
                {chapter.desc}
              </p>
              <div className="inline-block px-3 py-1 rounded bg-card text-gold text-xs font-inter font-semibold" data-id="element-323">
                {chapter.pages}
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-secondary border border-gold rounded-xl p-6 md:p-8 relative" data-id="element-324">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary px-4 py-1 border border-gold rounded-full text-gold font-inter font-bold text-sm whitespace-nowrap" data-id="element-325">
            También incluye:
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8 mt-4 text-center sm:text-left" data-id="element-326">
            {extras.map((extra, idx) => <div key={idx} className="flex items-center sm:items-start gap-3 justify-center sm:justify-start" data-id="element-327">
                <CheckIcon className="w-5 h-5 text-gold flex-shrink-0" data-id="element-328" />
                <span className="font-inter text-warm-white text-sm md:text-base" data-id="element-329">
                  {extra}
                </span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}